"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdapterAuthSSS = void 0;
const stateMachine_1 = require("../stateMachine");
const constants_1 = require("../constants");
const types_1 = require("../types");
class AdapterAuthSSS {
    constructor(authenticator) {
        this.subscribers = [];
        this.initialize = async () => {
            const documentFormats = await this.getDtoFormat();
            this.stateMachine.init({
                state: types_1.AuthStateEnum.CREDENTIALS_REQUIRED,
                type: types_1.AuthCredentialsEnum.USER,
                data: { documentFormats: documentFormats ?? [] },
            });
        };
        this.validateCredentials = async (credentials) => {
            if (credentials.type === types_1.AuthCredentialsEnum.USER) {
                this.doUserValidations(credentials);
            }
            else if (credentials.type === types_1.AuthCredentialsEnum.PASSWORD) {
                this.login(credentials.data);
            }
            else {
                throw new Error('[AdapterAuthSSS]: Not a valid credential type');
            }
        };
        this.getCurrentState = () => this.stateMachine.getCurrentState();
        this.getDtoFormat = async () => {
            try {
                const documentFormats = await this.authService.getDocumentFormats();
                return documentFormats;
            }
            catch (error) {
                this.stateMachine.setState({ state: types_1.AuthStateEnum.TECHNICAL_ERROR, data: error });
            }
        };
        this.login = async (loginData) => {
            try {
                const result = await this.authService.login(loginData);
                this.stateMachine.onTransition({ state: types_1.AuthStateEnum.AUTHENTICATION_COMPLETED, data: result });
                return result;
            }
            catch (err) {
                const error = err;
                if (error.httpStatus === constants_1.STATUS_ERROR) {
                    this.stateMachine.onTransition({ state: types_1.AuthStateEnum.TECHNICAL_ERROR, data: error });
                }
                else if (error.httpStatus === constants_1.STATUS_INVALID) {
                    this.stateMachine.onTransition({ state: types_1.AuthStateEnum.INVALID_CREDENTIALS, data: error });
                }
                else if (error.httpStatus === constants_1.PRECONDITION_FAILED) {
                    this.stateMachine.onTransition({ state: types_1.AuthStateEnum.AUTHENTICATION_FAILED, data: error });
                }
                else {
                    this.stateMachine.onTransition({ state: types_1.AuthStateEnum.TECHNICAL_ERROR, data: error });
                }
            }
        };
        this.doUserValidations = async (dto) => {
            try {
                const passwordPositions = await this.authService.getPasswordPositions(dto.data.value, dto.type);
                this.stateMachine.onTransition({
                    state: types_1.AuthStateEnum.CREDENTIALS_REQUIRED,
                    type: types_1.AuthCredentialsEnum.PASSWORD,
                    data: { passwordPositions },
                });
            }
            catch (error) {
                this.stateMachine.setState({ state: types_1.AuthStateEnum.TECHNICAL_ERROR, data: error, type: types_1.AuthCredentialsEnum.USER });
            }
        };
        this.logout = async () => {
            if (this.stateMachine.getCurrentState().state !== types_1.AuthStateEnum.AUTHENTICATION_COMPLETED) {
                return;
            }
            try {
                await this.authService.logout();
                this.stateMachine.onTransition({ state: types_1.AuthStateEnum.USER_LOGGED_OUT });
            }
            catch (err) {
                const error = err;
                if (error.httpStatus === constants_1.STATUS_ERROR) {
                    this.stateMachine.setState({ state: types_1.AuthStateEnum.TECHNICAL_ERROR, data: error });
                }
                else {
                    this.stateMachine.setState({ state: types_1.AuthStateEnum.LOGOUT_FAILED, data: error });
                }
            }
        };
        this.authService = authenticator;
        this.stateMachine = new stateMachine_1.StateMachine({ stateList: types_1.authStates, inititialState: { state: types_1.AuthStateEnum.IDLE } });
    }
    onStateChange(callback) {
        this.subscribers.push(callback);
        this.stateMachine.setSubscribers(this.subscribers);
    }
}
exports.AdapterAuthSSS = AdapterAuthSSS;
//# sourceMappingURL=AdapterAuthSSS.js.map